import React, { forwardRef } from 'react';
import { makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  sfIcon: {
    width: '22px', 
    height: '22px'
  },
  sfIconBrandBg: {
    fill: "var(--slds-g-color-palette-cloud-blue-60)",
  }
});

const SFIcon = forwardRef(({ iconInfo, size = 'small' }, ref) => {
  const classes = useStyles();
  if (!iconInfo) return null;
  const isSfBrandIcon = iconInfo.category === "utility" && iconInfo.name === "salesforce1";
  
  // Format name for CSS (e.g. "campaign_member" -> "campaign-member")
  const cssName = iconInfo.name.replace(/_/g, '-');
  
  // This path points to the local icons copied by Webpack
  const iconPath = `/assets/icons/${iconInfo.category}-sprite/svg/symbols.svg#${iconInfo.name}`;

  return (
    <span ref={ref} className={`slds-icon_container slds-icon-${iconInfo.category}-${cssName}`} title={iconInfo.title}>
      <svg className={`slds-icon slds-icon_${size} ${classes.sfIcon} ${isSfBrandIcon ? classes.sfIconBrandBg : ''}`} 
          aria-hidden="true">
        <use xlinkHref={iconPath}></use>
      </svg>
      <span className="slds-assistive-text">{iconInfo.title}</span>
    </span>
  );
});

export default SFIcon;